import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Checkbox from '../../../../components/ui/Checkbox';
import {
  apiPhotoGetPartners,
  apiPhotoRemove,
  apiPhotoSend,
} from '../../../../actions/photoActions';

function Partners({ albumId, disabled = false }: { albumId: number; disabled?: boolean }) {
  const [partners, setPartners] = useState<any>([]);
  const [selected, setSelected] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadPartners(true);
  }, []);

  const loadPartners = async (init: boolean = false) => {
    setLoading(true);
    const partners = await apiPhotoGetPartners(albumId);
    setPartners(partners);
    if (init) {
      setSelected([]);
    }
    setLoading(false);
  };

  const sendAll = async () => {
    setLoading(true);
    //await apiPhotoSend(albumId, selected);
    setSelected([]);
    loadPartners();
  };

  const onChangeSelected = (partnerId: number) => {
    let _selected = selected;
    if (_selected.indexOf(partnerId) === -1) {
      _selected.push(partnerId);
    } else {
      _selected = _selected.filter(id => partnerId !== id);
    }
    setSelected([..._selected]);
  };

  return (
    <div className="video-page-partners">
      {loading ? (
        <div className="video-page-partners-loader">
          <div className="blue-spinner" />
        </div>
      ) : (
        <>
          <div className="video-page-block-top">
            {!disabled && partners.length > 0 && (
              <Checkbox
                label={''}
                checked={partners.length > 0 && partners.length === selected.length}
                onChange={() => {
                  if (partners.length === selected.length) {
                    setSelected([]);
                  } else {
                    setSelected(partners.map((partner: any) => partner.id));
                  }
                }}
              />
            )}
            <span className="video-page-block-title">Partners</span>
            {partners.length > 0 && selected.length > 0 && (
              <button className={`video-page-partners-element-button`} onClick={sendAll}>
                <i className="fa fa-send" />
                Send selected
              </button>
            )}
          </div>
          {disabled ? (
            <div className="video-page-partners-empty">
              <span className="video-page-partners-empty-text">
                Not enough data to send to partners
              </span>
            </div>
          ) : (
            <div className="video-page-partners-elements">
              {partners.map((partner: any) => {
                return (
                  <Partner
                    partner={partner}
                    albumId={albumId}
                    selected={selected.indexOf(partner.id) !== -1}
                    onChangeSelected={() => {
                      onChangeSelected(partner.id);
                    }}
                  />
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
}

function Partner({ partner, albumId, selected, onChangeSelected }: any) {
  const [loading, setLoading] = useState(false);
  const [isSend, setIsSend] = useState(0);

  useEffect(() => {
    setIsSend(partner.send);
  }, []);

  const send = () => {
    setLoading(true);

    apiPhotoSend(albumId, partner.id)
      .then((status: boolean) => {
        if (status) {
          setIsSend(1);
        }
        setLoading(false);
      })
      .catch(() => {});
  };

  const remove = () => {
    setLoading(true);

    apiPhotoRemove(albumId, partner.id)
      .then(() => {
        setLoading(false);
        setIsSend(0);
      })
      .catch(() => {});
  };

  return (
    <div className="video-page-partners-element">
      <div className="video-page-partners-element-top">
        <Checkbox label={''} checked={selected} onChange={onChangeSelected} />
        <span className="video-page-partners-element-name">{partner.name}</span>
        {isSend === 1 && <span className="red-circle" />}
        {isSend === 2 && <span className="green-circle" />}
        {isSend === 0 ? (
          <button
            className={`video-page-partners-element-button ${loading ? 'loading' : ''}`}
            disabled={loading}
            onClick={send}
          >
            {loading && <span className="spinner" />}
            <i className="fa fa-send" />
            Send
          </button>
        ) : (
          <button
            className={`video-page-partners-element-button red ${loading ? 'loading' : ''}`}
            disabled={loading}
            onClick={remove}
          >
            {loading && <span className="spinner" />}
            <i className="fa fa-trash" />
            Remove
          </button>
        )}
      </div>
    </div>
  );
}

export default Partners;
